export default function() {
  return {
    id_vendedor: "",
    id_unidade: "",
    nome_vendedor: "",
    nome_unidade: "",

    id_produto: "",
    id_plano: "",
    nome_produto: "",
    nome_plano: "",
  };
}
